import axios from 'axios'
import { deviceUrl, baseUrl, metricUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 查询设备信息
export function gethelmet(params) {
  const url = deviceUrl + '/device/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询设备信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 新增设备
export function addHelmet(params) {
  const url = deviceUrl + '/device/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '新增设备', res)
    }
    return Promise.resolve(res.data)
  })
}

// 更新设备
export function updateHelmet(params) {
  const url = deviceUrl + '/device/update'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '更新设备', res)
    }
    return Promise.resolve(res.data)
  })
}

// 更新设备
export function deleteHelmet(params) {
  const url = deviceUrl + '/device/delete?id=' + params
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '删除设备', res)
    }
    return Promise.resolve(res.data)
  })
}
// 绑定设备
export function bindHelmet(params) {
  const url = deviceUrl + '/device/bind'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '编辑设备绑定人员', res)
    }
    return Promise.resolve(res.data)
  })
}
// 编辑设备
export function editHelmet(params) {
  const url = deviceUrl + '/device/bind'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '编辑设备', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询用户信息列表
export function getUser(params) {
  const url = baseUrl + '/user/list'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询可绑定设备的用户列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询设备绑定记录列表
export function getHelmetBindRecord(params) {
  const url = deviceUrl + '/device/record/page'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询设备绑定记录列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取echart高度
export function chartRecord(params) {
  const url = metricUrl + '/location/chart/record'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取设备高度历史数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取echart心率+体温+血氧
export function healthStatusRecord(params) {
  const url = metricUrl + '/healthStatus/chart/record'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取设备心率+体温+血氧历史数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取echart信号强度
export function baseStationRecord(params) {
  const url = metricUrl + '/baseStation/chart/record'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取设备信号强度历史数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取echart休眠状态+戴帽状态+充电状态
export function deviceStatusRecord(params) {
  const url = metricUrl + '/deviceStatus/chart/status'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取设备休眠状态+戴帽状态+充电状态历史数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取echart电量
export function deviceStatusBattery(params) {
  const url = metricUrl + '/deviceStatus/chart/battery'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取设备电量历史数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 导出模板
export function exportExcel() {
  const url = deviceUrl + '/device/export'
  return axios({
    method: 'get',
    url: url,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('设备管理', '下载模板', { status: res.status, data: { state: -1, msg: '下载模板失败' } })
    }
    return Promise.resolve(res.data)
  })
}
// 批量导入设备
export function importExcel(params) {
  const url = deviceUrl + '/device/import'
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('设备管理', '批量导入设备', { status: res.status, data: { state: -1, msg: '批量导入设备失败' } })
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 查询未绑定用户的所有安卓设备
 */
export function unBindDeviceList(params) {
  return axios({
    method: 'get',
    url: `${deviceUrl}/device/list?binded=0`,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询未绑定用户的所有安卓设备', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 用户换绑设备
 */
export function deviceUserBind(data) {
  return axios({
    method: 'post',
    url: `${deviceUrl}/device/user/bind`,
    data,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '用户换绑设备', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 查询设备详情数据列表分页
 */
export function findUserDevicePage(params) {
  return axios({
    method: 'get',
    url: `${metricUrl}/device/find/user/device/page`,
    params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询设备详情数据列表分页', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 导出设备详情数据列表
 */
export function findUserDeviceExport(params) {
  return axios({
    method: 'get',
    url: `${metricUrl}/device/find/user/device/export`,
    params,
    responseType: 'blob',
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

/**
 * 导出设备列表
 */
export function exportHelmet(params) {
  return axios({
    method: 'get',
    url: `${deviceUrl}/device/list/export`,
    params,
    responseType: 'blob',
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

/**
 * 查询用户历史绑定设备
 */
export function findUserBingDeviceLog(params) {
  return axios({
    method: 'get',
    url: `${deviceUrl}/device/user/bind/record`,
    params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('精准调度', '查询用户历史绑定设备', res)
    }
    return Promise.resolve(res.data)
  })
}